export default {
    dependencies: ['$element'],
    callable: rootEle => {
        const finnHeaderEle = document.body.querySelector('.topmenu');
        const productEle = rootEle.querySelector('[data-product]');

        const FINN_HEADER_HEIGHT = finnHeaderEle
            ? finnHeaderEle.clientHeight
            : 55;

        productEle.addEventListener('click', () => {
            if (getScrollTop() > FINN_HEADER_HEIGHT) {
                productEle.classList.toggle('is-expanded');
            }
        });

        function getScrollTop() {
            return (
                document.body.scrollTop || document.documentElement.scrollTop
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxHeader.js